/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_Requires_MixdownInputs */



/**
* | output |
* | --- |
* | "Requires Export Mixdown to be enabled" |
*
* @param {Audio_Description_Export_Video_Requires_MixdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_requires_mixdown = /** @type {((inputs?: Audio_Description_Export_Video_Requires_MixdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_Requires_MixdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nécessite l'export du mixdown")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfordert, dass Export Mixdown aktiviert ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Richiede che Export Mixdown sia abilitato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для корректной работы требуется включить функцию Export Mixdown.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Requiere que Export Mixdown esté habilitado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需要启用导出混音功能")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートミックスダウンを有効にする必要があります")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्सपोर्ट मिक्सडाउन को सक्षम करना आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Requer que a opção Export Mixdown esteja ativada.")
	return /** @type {LocalizedString} */ ("Requires Export Mixdown to be enabled")
});